import { reloadPage } from './reloadPage';

const MAX_RETRIES = 3;
const INITIAL_RETRY_DELAY_MS = 500;

function isChunkLoadError(error: unknown): error is Error {
    return error instanceof Error && error.name === 'ChunkLoadError';
}

export async function importWithRetry<T>(
    importFn: () => Promise<T>,
    retries = MAX_RETRIES,
    delay = INITIAL_RETRY_DELAY_MS,
): Promise<T> {
    try {
        return await importFn();
    } catch (error) {
        if (isChunkLoadError(error) && retries > 0) {
            console.warn(`ChunkLoadError, retrying in ${delay}ms (${retries} retries left)`);
            await new Promise((resolve) => setTimeout(resolve, delay));
            return importWithRetry(importFn, retries - 1, delay * 2);
        }

        if (isChunkLoadError(error)) {
            console.error('ChunkLoadError, all retries exhausted - reloading page');
            reloadPage();
        }

        throw error;
    }
}
